import { MutableRefObject } from 'react'
import {
  PLAY_STORE_URL as ANDROID_APP_URL,
  APP_STORE_URL as IOS_APP_URL,
} from '@/hooks/useQuickLink'

export function performStoreRedirect(
  deviceOS: string | null | undefined,
  redirectedRef: MutableRefObject<boolean>,
  logExternalNavigation: (url?: string, external?: boolean) => void,
): void {
  if (redirectedRef.current) return // already redirected
  if (typeof window === 'undefined') return // SSR guard
  if (deviceOS === 'ios') {
    logExternalNavigation(IOS_APP_URL, true)
    redirectedRef.current = true
    window.location.assign(IOS_APP_URL)
  } else if (deviceOS === 'android') {
    logExternalNavigation(ANDROID_APP_URL, true)
    redirectedRef.current = true
    window.location.assign(ANDROID_APP_URL)
  }
}
